export const GET_LEAVES_DATA: string = "GET_LEAVES_DATA";
export const LOADING: string = "LOADING";

